import React from "react";
import { Star, Quote } from "lucide-react";

const ITEMS = [
  {
    name: "Dr. Aanya Sharma",
    rank: "AIR 124, NEET PG 2024",
    text: "The AI explanations are gold. I went from 60% to 84% in mocks in just 3 months with DearDr.",
  },
  {
    name: "Dr. Rohit Verma",
    rank: "AIR 318, NEET PG 2024",
    text: "Subject-wise mini tests are exactly what I needed. The analytics showed me my weak areas immediately.",
  },
  {
    name: "Dr. Meghana Iyer",
    rank: "AIR 502, NEET PG 2024",
    text: "Grand tests felt like the real exam. Helped me build stamina and time management.",
  },
  {
    name: "Dr. Karan Patel",
    rank: "Currently preparing",
    text: "Daily 10 MCQs keep me consistent. The streak feature is addictive in the best way.",
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" className="py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-blue-700 bg-blue-50 px-3 py-1.5 rounded-full">
            <span className="h-1.5 w-1.5 rounded-full bg-blue-600" /> Testimonials
          </div>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900 mt-4">
            Loved by future doctors across India
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {ITEMS.map((t, i) => (
            <div
              key={i}
              data-testid={`testimonial-${i}`}
              className="relative bg-white border border-slate-200 rounded-2xl p-6 lift"
            >
              <Quote className="h-7 w-7 text-blue-100 absolute right-4 top-4" />
              <div className="flex items-center gap-1 text-amber-500 mb-3">
                {Array.from({ length: 5 }).map((_, idx) => (
                  <Star key={idx} className="h-4 w-4 fill-current" />
                ))}
              </div>
              <p className="text-sm text-slate-700 leading-relaxed">&ldquo;{t.text}&rdquo;</p>
              <div className="mt-5 pt-4 border-t border-slate-100">
                <div className="font-bold text-slate-900 text-sm">{t.name}</div>
                <div className="text-xs text-blue-700 font-semibold">{t.rank}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
